import { render, staticRenderFns } from "./ChatterProjectMemberGrid.vue?vue&type=template&id=5dbfb7a1"
import script from "./ChatterProjectMemberGrid.vue?vue&type=script&lang=js"
export * from "./ChatterProjectMemberGrid.vue?vue&type=script&lang=js"
import style0 from "./ChatterProjectMemberGrid.vue?vue&type=style&index=0&id=5dbfb7a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports